import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _entitySpecs;

var defaultDimensions = 'original';
var branding = {
  original: ['200x40', '400x80']
};
var teamImage = {
  original: ['480xauto', '960xauto', '1440xauto', '1920xauto'],
  '16:9': ['256x144', '480x270', '512x288', '768x432', '960x540', '1440x810', '1920x1080']
};
var player = {
  original: ['320xauto', '480xauto', '960xauto', '1440xauto', '1920xauto'],
  '1:1': ['32x32', '64x64', '100x100', '128x128', '150x150', '200x200', '300x300', '450x450'],
  '4:5': ['256x320', '320x400', '480x600', '512x640', '960x1200', '1440x1800', '1920x2400']
};
var referee = {
  original: ['320xauto', '480xauto', '960xauto', '1440xauto', '1920xauto'],
  '1:1': ['32x32', '64x64', '100x100', '128x128', '150x150', '200x200', '300x300', '450x450']
};
var contact = {
  original: ['32xauto', '64xauto', '128xauto', '150xauto', '200xauto', '300xauto', '450xauto'],
  '1:1': ['32x32', '64x64', '128x128', '150x150', '200x200', '300x300', '450x450']
};
var user = {
  original: ['32xauto', '64xauto', '100xauto', '128xauto', '200xauto', '300xauto'],
  '1:1': ['32x32', '64x64', '100x100', '128x128', '200x200', '300x300']
};
var venue = {
  '1:1': ['64x64', '128x128', '192x192']
};
var competition = {
  '1:1': ['32x32', '64x64', '96x96', '128x128', '192x192']
};
var district = {
  '1:1': ['32x32', '64x64', '96x96']
};
var emblem = {
  '1:1': ['20x20', '32x32', '40x40', '60x60', '64x64', '96x96', '128x128', '192x192']
};
var refereeGroup = {
  '1:1': ['25x25', '50x50', '100x100', '200x200']
};
var news = {
  original: ['480xauto', '960xauto', '1440xauto', '1920xauto'],
  '1:1': ['64x64', '96x96', '120x120', '128x128', '192x192', '240x240', '360x360', '480x480', '648x648'],
  '16:9': ['480x270', '960x540', '1440x810', '1920x1080'],
  '3:2': ['480x320', '960x640', '1440x960', '1920x1280']
};
var gallery = {
  original: ['480xauto', '960xauto', '1440xauto', '1920xauto'],
  '1:1': ['64x64', '128x128', '192x192'],
  '16:9': ['480x270', '960x540', '1440x810', '1920x1080'],
  '3:2': ['336x224', '408x272', '504x336', '612x408', '948x632', '1422x948']
};
var video = {
  '1:1': ['64x64', '128x128', '192x192'],
  '16:9': ['320x180', '336x189', '408x230', '480x270', '504x284', '612x344', '948x533', '960x540', '1422x800', '1440x810', '1920x1080'],
  original: ['320x180', '480x270', '960x540', '1440x810', '1920x1080']
};
var matchEvent = {
  original: ['320xauto', '480xauto', '960xauto', '1440xauto', '1920xauto'],
  '16:9': ['320x180', '480x270', '960x540', '1440x810', '1920x1080']
};

var getSizes = function getSizes(dimensions) {
  return dimensions.map(function (value) {
    var size = value.split('x');
    var width = size[0] === 'auto' ? 'auto' : parseInt(size[0]);
    var height = size[1] === 'auto' ? 'auto' : parseInt(size[1]);
    return {
      height: height,
      width: width
    };
  });
};

export var ImageEntity;

(function (ImageEntity) {
  ImageEntity["Branding"] = "branding";
  ImageEntity["Emblem"] = "emblem";
  ImageEntity["News"] = "news";
  ImageEntity["Gallery"] = "gallery";
  ImageEntity["Video"] = "video";
  ImageEntity["Player"] = "player";
  ImageEntity["Referee"] = "referee";
  ImageEntity["Contact"] = "contact";
  ImageEntity["User"] = "user";
  ImageEntity["Venue"] = "venue";
  ImageEntity["Competition"] = "competition";
  ImageEntity["District"] = "district";
  ImageEntity["TeamImage"] = "team-image";
  ImageEntity["MatchEvent"] = "match-event";
  ImageEntity["RefereeGroup"] = "referee-group";
})(ImageEntity || (ImageEntity = {}));

var entitySpecs = (_entitySpecs = {}, _defineProperty(_entitySpecs, ImageEntity.Branding, function () {
  return {
    allowedSizes: getSizes(branding['original']),
    fileTypes: ['svg', 'png']
  };
}), _defineProperty(_entitySpecs, ImageEntity.Emblem, function () {
  return {
    allowedSizes: getSizes(emblem['1:1']),
    fileTypes: ['svg', 'webp', 'png']
  };
}), _defineProperty(_entitySpecs, ImageEntity.News, function (ratio) {
  var dimensions = ratio && ratio in news ? news[ratio] : news[defaultDimensions];
  return {
    allowedSizes: getSizes(dimensions),
    fileTypes: ['svg', 'webp', 'jpeg']
  };
}), _defineProperty(_entitySpecs, ImageEntity.Gallery, function (ratio) {
  var dimensions = ratio && ratio in gallery ? gallery[ratio] : gallery[defaultDimensions];
  return {
    allowedSizes: getSizes(dimensions),
    fileTypes: ['svg', 'webp', 'jpeg']
  };
}), _defineProperty(_entitySpecs, ImageEntity.Video, function (ratio) {
  var dimensions = ratio && ratio in video ? video[ratio] : video[defaultDimensions];
  return {
    allowedSizes: getSizes(dimensions),
    fileTypes: ['svg', 'webp', 'jpeg']
  };
}), _defineProperty(_entitySpecs, ImageEntity.Player, function (ratio) {
  var dimensions = ratio && ratio in player ? player[ratio] : player[defaultDimensions];
  return {
    allowedSizes: getSizes(dimensions),
    fileTypes: ['svg', 'webp', 'jpeg']
  };
}), _defineProperty(_entitySpecs, ImageEntity.Referee, function (ratio) {
  var dimensions = ratio && ratio in referee ? referee[ratio] : referee[defaultDimensions];
  return {
    allowedSizes: getSizes(dimensions),
    fileTypes: ['svg', 'webp', 'jpeg']
  };
}), _defineProperty(_entitySpecs, ImageEntity.Contact, function (ratio) {
  var dimensions = ratio && ratio in contact ? contact[ratio] : contact[defaultDimensions];
  return {
    allowedSizes: getSizes(dimensions),
    fileTypes: ['svg', 'webp', 'jpeg']
  };
}), _defineProperty(_entitySpecs, ImageEntity.User, function (ratio) {
  var dimensions = ratio && ratio in user ? user[ratio] : user[defaultDimensions];
  return {
    allowedSizes: getSizes(dimensions),
    fileTypes: ['svg', 'webp', 'jpeg']
  };
}), _defineProperty(_entitySpecs, ImageEntity.Venue, function () {
  return {
    allowedSizes: getSizes(venue['1:1']),
    fileTypes: ['svg', 'webp', 'jpeg']
  };
}), _defineProperty(_entitySpecs, ImageEntity.Competition, function () {
  return {
    allowedSizes: getSizes(competition['1:1']),
    fileTypes: ['svg', 'webp', 'png', 'jpeg']
  };
}), _defineProperty(_entitySpecs, ImageEntity.District, function () {
  return {
    allowedSizes: getSizes(district['1:1']),
    fileTypes: ['svg', 'webp', 'png', 'jpeg']
  };
}), _defineProperty(_entitySpecs, ImageEntity.TeamImage, function (ratio) {
  var dimensions = ratio && ratio in teamImage ? teamImage[ratio] : teamImage[defaultDimensions];
  return {
    allowedSizes: getSizes(dimensions),
    fileTypes: ['svg', 'webp', 'jpeg']
  };
}), _defineProperty(_entitySpecs, ImageEntity.MatchEvent, function (ratio) {
  var dimensions = ratio && ratio in matchEvent ? matchEvent[ratio] : matchEvent[defaultDimensions];
  return {
    allowedSizes: getSizes(dimensions),
    fileTypes: ['svg', 'webp', 'jpeg']
  };
}), _defineProperty(_entitySpecs, ImageEntity.RefereeGroup, function () {
  return {
    allowedSizes: getSizes(refereeGroup['1:1']),
    fileTypes: ['svg', 'webp', 'png', 'jpeg']
  };
}), _entitySpecs);

var getEntitySpec = function getEntitySpec(entity, ratio) {
  return entitySpecs[entity](ratio);
};

export { getEntitySpec };
//# sourceMappingURL=entitySpec.js.map